import { useTraderWallets } from '@entities/trades/wallet';
import type { ITraderWalletTableColumns } from '@entities/trades/wallet';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import { Table, THead, TBody, TableContainer, TableProvider } from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const WalletsWidget = () => {
  const {
    traderWallets,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useTraderWallets();

  const { columnTitles, renderRow, renderFilterElement } = useTableSettings({
    refetch,
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (traderWallets) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<ITraderWalletTableColumns> columnTitles={columnTitles} {...filter}>
          <TableContainer>
            <Table>
              <THead items={traderWallets.data} renderItem={renderFilterElement} />
              <TBody items={traderWallets.data} renderItem={renderRow} />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={traderWallets.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default WalletsWidget;
